// extracted by mini-css-extract-plugin
export default {"formItem":"RecordUpdatesCommon_formItem__u0i7c","bold":"RecordUpdatesCommon_bold__9vN4E","underlined":"RecordUpdatesCommon_underlined__dLE1Q"};